export default __webpack_public_path__ + "images/electricians.191fd0b2b308c4f6719ade3ad0f9f196.svg";